import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import HeroBannerSimple from '@/shared/content/blocks/hero-banner/HeroBannerSimple.vue';
import { ImageFileModel } from '@/types/B2BcontentServerContract';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { HeroBannerBlocksTileModel } from '@/types/B2CcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroBannerSimpleBlocksTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: HeroBannerBlocksTileModel,
}



const image = computed<ImageFileModel>(() => {
    return props.content.media.model;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(HeroBannerSimple, {
    scrim: __props.content.isScrimEnabled,
    image: _unref(image)
  }, {
    default: _withCtx(() => [
      _createVNode(BlockList, {
        blocks: __props.content.tiles,
        nested: true,
        parent: __props.content.type,
        class: _normalizeClass(["c-hero-banner__content", {'c-hero-banner__content-shadows-enabled': __props.content.isScrimEnabled }])
      }, null, 8, ["blocks", "parent", "class"])
    ]),
    _: 1
  }, 8, ["scrim", "image"]))
}
}

})